import { render, staticRenderFns } from "./PowerRankingsDetail.vue?vue&type=template&id=7062f05a&"
import script from "./PowerRankingsDetail.vue?vue&type=script&lang=js&"
export * from "./PowerRankingsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PowerRankingsDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports